/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ExternalClient,
    ExternalClientFromJSON,
    ExternalClientFromJSONTyped,
    ExternalClientToJSON,
    ExternalPartners,
    ExternalPartnersFromJSON,
    ExternalPartnersFromJSONTyped,
    ExternalPartnersToJSON,
} from './';

/**
 * 
 * @export
 * @interface ExternalClientIEnumerableExternalPartnerResponse
 */
export interface ExternalClientIEnumerableExternalPartnerResponse {
    /**
     * 
     * @type {ExternalPartners}
     * @memberof ExternalClientIEnumerableExternalPartnerResponse
     */
    partner?: ExternalPartners;
    /**
     * 
     * @type {number}
     * @memberof ExternalClientIEnumerableExternalPartnerResponse
     */
    responseCode?: number;
    /**
     * 
     * @type {Array<ExternalClient>}
     * @memberof ExternalClientIEnumerableExternalPartnerResponse
     */
    data?: Array<ExternalClient> | null;
}

export function ExternalClientIEnumerableExternalPartnerResponseFromJSON(json: any): ExternalClientIEnumerableExternalPartnerResponse {
    return ExternalClientIEnumerableExternalPartnerResponseFromJSONTyped(json, false);
}

export function ExternalClientIEnumerableExternalPartnerResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalClientIEnumerableExternalPartnerResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'partner': !exists(json, 'partner') ? undefined : ExternalPartnersFromJSON(json['partner']),
        'responseCode': !exists(json, 'responseCode') ? undefined : json['responseCode'],
        'data': !exists(json, 'data') ? undefined : (json['data'] === null ? null : (json['data'] as Array<any>).map(ExternalClientFromJSON)),
    };
}

export function ExternalClientIEnumerableExternalPartnerResponseToJSON(value?: ExternalClientIEnumerableExternalPartnerResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'partner': ExternalPartnersToJSON(value.partner),
        'responseCode': value.responseCode,
        'data': value.data === undefined ? undefined : (value.data === null ? null : (value.data as Array<any>).map(ExternalClientToJSON)),
    };
}


